import Vue from 'vue'
import Vuex from 'vuex'
import I18n from './module/i18n'
import Profile from './module/profile'
import Group from './module/group'
import Organization from './module/organization'
import Status from './module/status'
import User from './module/user'
import Position from './module/position'
import Document from './module/document'
import GroupDocument from './module/group-document'
import DocumentItem from './module/document-item'
import ChecklistItemStatus from './module/checklist-item-status'
import Checklist from './module/checklist'
import ChecklistItem from './module/checklist-item'
import GroupChecklistItem from './module/group-checklist-item'
import GroupAlias from './module/group-alias'
import Comment from './module/comment'
import Audit from './module/audit'
import Tag from './module/tag'
import Permission from './module/permission'
import GroupPermission from './module/group-permission'
import GroupFAQ from './module/group-faq'
import FAQ from './module/faq'
import Menu from './module/menu'
import Summary from './module/summary'
import Chat from './module/chat'
import Notification from './module/notification'
import Report from './module/report'
import Dashboard from './module/dashboard'
import Survey from './module/survey'
import Library from './module/library'
import CategoryChk from './module/category-chk'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    I18n,
    Profile,
    Group,
    Organization,
    Status,
    User,
    Position,
    Document,
    GroupDocument,
    DocumentItem,
    ChecklistItemStatus,
    Checklist,
    ChecklistItem,
    GroupChecklistItem,
    GroupAlias,
    Comment,
    Audit,
    Tag,
    Permission,
    GroupPermission,
    GroupFAQ,
    FAQ,
    Menu,
    Summary,
    Chat,
    Notification,
    Report,
    Dashboard,
    Survey,
    Library,
    CategoryChk
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js